import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { TranslateModule } from '@ngx-translate/core'
import { ChunkLoadErrorService } from '../../services/chunk-load-error.service'
import { AppUpdateService } from '../../services/app-update.service'

// Eagerly loaded in the app shell so recovery never needs another lazy chunk.
@Component({
  selector: 'app-update-prompt',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './update-prompt.component.html',
  styleUrl: './update-prompt.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpdatePromptComponent {
  private readonly updates = inject(AppUpdateService)
  readonly update = inject(ChunkLoadErrorService)
}
